import React, { useRef } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { css } from '@emotion/react';
import { useTheme } from '@mui/material/styles';

const createTabsStyles = (isSmall, vertical) =>
	css({
		...(vertical && {
			flexContainer: {
				width: vertical && isSmall ? '50px' : 'inherit',
				alignItems: 'flex-start'
			}
		}),
		'.MuiTabs-indicator': {
			display: 'flex',
			justifyContent: 'center',
			'& > span': {
				maxWidth: 40,
				width: '100%'
			}
		}
	});

const StyledTabs = React.forwardRef(({ isSmall, vertical, ...props }, ref) => (
	<Tabs
		ref={ref}
		{...props}
		variant="scrollable"
		scrollButtons="auto"
		TabIndicatorProps={{ children: <span /> }}
		css={createTabsStyles(isSmall, vertical)}
	/>
));

const createTabStyles = (
	{ vertical, isColorReversed, isSmall, width },
	theme
) =>
	css({
		...(!vertical && { padding: 0 }),
		...(vertical && isSmall && { minWidth: '50px' }),
		...(!isSmall && { whiteSpace: 'nowrap' }),
		...(isSmall && { padding: 0 }),
		textTransform: 'none',

		cursor: 'pointer',
		fontWeight: theme.typography.fontWeightRegular,
		//fontSize: theme.typography.pxToRem(11),
		fontSize: `clamp(${theme.typography.pxToRem(
			8
		)},${theme.typography.pxToRem(10)} + 0.5vw, ${theme.typography.pxToRem(
			15
		)})`,
		marginRight: theme.spacing(1),
		'&:focus': {
			opacity: 1
		}
	});
const VERTICAL_PADDING = 16;

function getOffsetWidth(el) {
	const elList = el?.getElementsByTagName('span') ?? [];
	return elList.length ? elList[0] * 2 * VERTICAL_PADDING : 160;
}

const StyledTab = ({ vertical, isColorReversed, isSmall, ...props }) => {
	const inputRef = useRef(null);
	const width = getOffsetWidth(inputRef.current);
	const theme = useTheme();
	return (
		<Tab
			ref={inputRef}
			disableRipple
			{...props}
			css={createTabStyles(
				{
					vertical,
					isColorReversed,
					isSmall,
					width
				},
				theme
			)}
		/>
	);
};

export { StyledTabs, StyledTab };
